import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button, Modal, Table, Alert, Spinner } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import { ViewManager } from '../../core/view-manager';
import FieldPreview from '../../components/Entity/FieldPreview';
import DGSH_voyage_double from '../components/DGSH_voyage_double';


export default function DataGridSelectionHook({ data, setData, entity = null, selectedRows, setSelectedRows, refreshData }) {


    const navigate = useNavigate()

    useEffect(() => {

    }, []);



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'test': return (
                            <span>Test</span>
                        );
                        case 'gyv_voyage_double': return (
                            <>
                                <DGSH_voyage_double entity={'gyv_voyage_double'} data={data} setData={setData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} refreshData={refreshData} />
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};